










import Vue from 'vue';
import Label from './Label.vue';
import Hint from './Hint.vue';
export default Vue.extend({
    components: { Hint, Label },
    props: {
        hint: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        strong: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: '',
        },
    },
    computed: {
        hasHint(): boolean {
            return !!this.$slots.hint || !!this.hint;
        },
    },
});
